import React, { useState } from "react";

export default function ExponentTool() {
  const [base, setBase] = useState(2);
  const [exp, setExp] = useState(3);

  const handleBase  = e => setBase(parseFloat(e.target.value) || 0);
  const handleExp   = e => setExp(parseFloat(e.target.value) || 0);

  const powerResult = Math.pow(base, exp);
  const sqrtResult  = base >= 0 ? Math.sqrt(base).toFixed(3) : "NaN";

  return (
    <div style={{ border: "1px solid #ccc", padding: 12, borderRadius: 6 }}>
      <h4>Exponent & Radical Tool</h4>
      <div style={{ marginBottom: 8 }}>
        <label>
          Base:&nbsp;
          <input
          className="inputBox"
            type="number"
            value={base}
            onChange={handleBase}
            style={{ width: 60 }}
          />
        </label>
        &nbsp;&nbsp;
        <label>
          Exponent:&nbsp;
          <input
          className="inputBox"
            type="number"
            value={exp}
            onChange={handleExp}
            style={{ width: 60 }}
          />
        </label>
      </div>
      <p>
        <strong>Result:</strong> {base} <sup>{exp}</sup> = {powerResult}
      </p>
      <p>
        <strong>√{base} =</strong> {sqrtResult}
      </p>
    </div>
  );
}
